export default "__VITE_ASSET__jY3WsbXh__"